import styled from "styled-components";

export const StyledTabContainer = styled.div`
    display: flex;
    margin-top: 40px;
`;

export const StyledDCIndicatorWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
`;
